import Config from '../launch/config'
import Phaser from 'phaser'

export default class BlitterStarPattern {
    constructor(props) {
        const boardSize = Config.boardSizes[Config.boardSize]
        const count =
            props.count || Config.boardSizes[Config.boardSize].blitterStarCount
        const width =
            props.width || boardSize.boardWidth + Config.boardPadding * 2
        const height =
            props.height || boardSize.boardHeight + Config.boardPadding * 2
        const tintCount = props.tintCount || count / 2

        this.blitter = Config.scene.add.blitter(
            props.x || 0,
            props.y || 0,
            props.texture
        )
        this.blitter.alpha = props.alpha || 1
        this.blitter.depth = props.depth || 1
        this.blitter[Config.namespace] = {type: 'star blitter'}

        for (let i = 0; i < count; ++i) {
            this.blitter.create(
                Phaser.Math.Between(0, width),
                Phaser.Math.Between(0, height)
            )
        }

        this.blitter.children.list.forEach((bob, index) => {
            if (index < tintCount) {
                bob.setTint(Math.random() * 0xffffff)
            }
        })
    }

    setPosition({x, y}) {}
}
